import React from "react";
import image from "./creature.png";
import "./Slide.scss";
import { Word } from "../shared";
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions";

// from horizontal, in degrees
const SLIDE_ANGLE = 55;

export default function Slide(props) {
  const { steps, graphemeIndex } = props;

  let scale = 80;
  if (steps > 2) scale = 70;
  if (steps > 3) scale = 60;
  if (steps > 4) scale = 54;

  const offset = scale / 8;

  const stairsHeight = steps * scale + scale / 4;
  const stairsWidth = (steps + 1) * scale;
  const slideWidth = stairsHeight * Math.tan(rads(90 - SLIDE_ANGLE));

  const containerStyle = {
    marginBottom: offset,
    marginLeft: offset,
    width: stairsWidth + slideWidth,
    height: stairsHeight + scale * 1.5,
  };

  // at top of stairs & interactive
  const clickable = props.interactive && graphemeIndex === steps - 1;

  return (
    <div className="slide-container" style={containerStyle}>
      {renderStairs()}
      {renderSlide()}
      {renderCreature()}
      {renderGraphemes()}
      {renderWord()}
    </div>
  );

  function renderStairs() {
    const lines = [];

    // add horizontal lines
    for (let i = 0; i <= steps; i++) lines.push(renderLine("h", i, i));
    // add vertical lines
    for (let i = 0; i < steps; i++) lines.push(renderLine("v", i + 1, i));

    return lines;
  }

  function renderLine(pos, x = 0, y = 0) {
    const style = {};
    if (pos === "h") {
      style.width = scale;
      style.height = scale / 4;
    } else if (pos === "v") {
      style.height = scale;
      style.width = scale / 4;
    }
    style.left = scale * x - offset;
    style.bottom = scale * y - offset;

    // "ground" is green
    let isBase = pos === "h" && (x === 0) & (y === 0);
    if (isBase) {
      style.background = "#2ECC40";
      style.width += offset * 2;
      style.zIndex = 2;
    }

    const key = `line-${pos}-${x}-${y}`;
    return <div key={key} className="slide-line" style={style} />;
  }

  function renderSlide() {
    let width = scale * steps + offset * 2;
    width /= Math.cos(rads(90 - SLIDE_ANGLE));
    const style = {
      width,
      bottom: scale * steps - offset,
      left: scale * (steps + 1) - offset,
      borderBottomWidth: scale / 4,
      borderBottomRightRadius: scale,
      borderBottomLeftRadius: scale,
      transform: `rotate(${SLIDE_ANGLE}deg)`,
    };
    return <div className="slide-curve" style={style} />;
  }

  function renderCreature() {
    const stepIndex = graphemeIndex + 1;

    const style = {
      width: scale * 0.8,
      bottom: scale * stepIndex + offset,
      left: scale * stepIndex,
    };
    if (clickable) style.cursor = "pointer";

    // at bottom of slide
    if (stepIndex > steps) {
      style.bottom = -offset;
      style.left = -offset + stairsWidth + slideWidth;
    }

    return (
      <img
        className="upanddown-creature"
        src={image}
        style={style}
        alt=""
        {...doNotUseAccessibleStaticElementInteractions({onClick: onClickCreature, onMouseDown: onClickCreature})}
      />
    );
  }

  function onClickCreature() {
    if (!clickable) return;
    props.onClickCreature();
  }

  function renderGraphemes() {
    // only for version 2
    if (props.versionId !== 2) return;
    return props.graphemes.map((g, i) => {
      if (graphemeIndex >= i) return;
      const style = {
        position: "absolute",
        left: scale * (i + 1) - offset,
        bottom: scale * (i + 1) + offset,
        width: scale,
        height: scale,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 64,
      };
      return (
        <Word key={i} style={style}>
          {g}
        </Word>
      );
    });
  }

  function renderWord() {
    // only for version 3
    if (props.versionId !== 3) return;
    if (graphemeIndex >= steps - 1) return;
    const word = props.graphemes.join("");
    const style = {
      position: "absolute",
      left: scale * steps - offset,
      bottom: scale * steps + offset,
      width: scale,
      height: scale,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 64,
    };
    return <Word style={style}>{word}</Word>;
  }
}

function rads(deg) {
  return deg * (Math.PI / 180);
}
